import React from "react";

// img
import ringIcon from "../../../assets/svg/event-types/ic-ring.svg";

// Jds
import { Text } from "@jds/core";

// Local
import Badge from "./Badge";

export default function EventTypeBadge(props) {
  return (
    <Badge
      icon={
        <img
          src={props?.src || ringIcon}
          alt="event type icon"
          style={{ width: "24px" }}
        />
      }
      text={
        <Text
          text={props?.label || "Wedding"}
          appearance="body-m-bold"
          color="white"
        />
      }
      {...props}
      sx={{
        backgroundColor: "rgba(117, 117, 117, 0.5)",
        borderRadius: "250px",
        padding: "4px 12px 4px 4px",
        ...props.sx,
      }}
    />
  );
}
